<template>
	<main>
		<Etapa :dadosComponentes="componentesEtapa" />
		<div v-if="Object.keys(dadosComponentes).length > 0">
			<div v-for="(componentes, etapa) in dadosComponentes" :key="etapa">
				<div v-if="etapaAtual == etapa">
					<component v-for="(componente, identificador) in componentes" :key="identificador"
						:is="componente.chave" v-bind="componente" :etapaComponente="etapaAtual"
						:localRealizacao="localRealizacao" :modulo="modulo" />
				</div>
			</div>
			<div v-if="exibirLoader" class="flex flex-col justify-center items-center gap-1 p-4">
				<Loader></Loader> <span class="text-sm">Aguarde</span>
			</div>
		</div>
		<div v-else class="flex justify-center pt-10">
			<Loader></Loader>
		</div>
	</main>
	<footer>
		<div v-if="!exibirLoader" class="">
			<Botoes :exibirVoltar="etapaAtual != 1"
				:labelSalvar="etapaAtual == totalEtapas ? 'Salvar e assinar' : 'Salvar'" @aoSalvar="salvarEtapa"
				@aoVoltar="voltarEtapa"></Botoes>
		</div>
	</footer>
</template>

<script>
import { defineComponent } from 'vue'
import Actions from '@/store/Actions'
import Rotas from '@/router/Rotas';
import Etapa from '@/components/Etapa.vue';
import EtapasService from '@/services/EtapasService';
import FuncoesHelper from '@/helpers/FuncoesHelper';

import Acessorio from '@/common/acessoriosEquipamentos/Acessorio.vue'
import Avaria from '@/common/avaria/Avaria.vue'
import Botoes from '@/components/Botoes.vue'
import Check from '@/common/Check.vue'
import Combustivel from '@/common/combustivel/Combustivel.vue'
import DadosAtendimento from '@/common/dadosAtendimento/DadosAtendimento.vue'
import DispensarVistoria from '@/common/DispensarVistoria.vue'
import EstadoPneu from '@/common/EstadoPneu.vue'
import Formulario from '@/common/Formulario.vue'
import Foto from '@/common/foto/Foto.vue'
import FotoConfirmacao from '@/common/FotoConfirmacao.vue';
import Icone from '@/components/Icone.vue'
import OpcaoMultiplaEscolha from '@/common/OpcaoMultiplaEscolha.vue'
import OpcaoUnica from '@/common/OpcaoUnica.vue'
import Texto from '@/common/Texto.vue'
import Loader from '@/components/Loader.vue'
import PreviewChecklist from '@/common/PreviewChecklist.vue';
import StatusComponenteConstant from '@/constants/StatusComponenteConstant';

/* eslint-disable vue/no-unused-components */
export default defineComponent({
	name: 'Etapas',
	components: {
		Acessorio,
		Avaria,
		Botoes,
		Check,
		Combustivel,
		DadosAtendimento,
		DispensarVistoria,
		EstadoPneu,
		Formulario,
		Foto,
		FotoConfirmacao,
		Icone,
		OpcaoMultiplaEscolha,
		OpcaoUnica,
		Texto,
		Loader,
		Etapa,
		PreviewChecklist
	},
	methods: {
		salvarEtapa() {
			if (FuncoesHelper.validarChecklistPreview()) {
				this.avancarEtapa();
				return;
			}
			this.exibirLoader = true;
			const respostas = this.dadosComponentes[this.etapaAtual];

			const { respostaAlterada, etapaInvalida } = Object.values(respostas).reduce((acc, componente) => {
				if (acc.etapaInvalida || acc.respostaAlterada) return acc;

				if (componente.validarNaEtapa && componente.status === StatusComponenteConstant.PENDENTE.chave) {
					acc.etapaInvalida = true;
				} else if (componente.respostaAlterada) {
					acc.respostaAlterada = true;
				} else if (componente.possuiSubcomponentes) {
					acc.respostaAlterada = Object.values(componente.opcoes).some(subcomponente => subcomponente.respostaAlterada);
				}

				return acc;
			}, { respostaAlterada: false, etapaInvalida: false })

			if (etapaInvalida) {
				this.exibirLoader = false;
				FuncoesHelper.notificar('error', 'Erro', 'Preencha todos os campos pendentes');
				return;
			}

			if (respostaAlterada) {
				this.$store.dispatch(Actions.SALVAR_ETAPA_CHECKLIST, {
					localRealizacao: this.localRealizacao,
					modulo: this.modulo,
					etapa: this.etapaAtual,
					respostas
				}) 	.then(() => {
						this.avancarEtapa();
					})
					.finally(() => {
						this.exibirLoader = false;
					});
			} else {
				this.exibirLoader = false;
				this.avancarEtapa();

			}
		},
		voltarEtapa() {
			if (this.etapaAtual > 1) {
				let etapaAnterior = Object.entries(this.dadosComponentes).filter(([etapa, componentes]) => etapa < this.etapaAtual && Object.values(componentes).length > 0)
				etapaAnterior = etapaAnterior.length > 0 ? etapaAnterior[etapaAnterior.length - 1][0] : null

				FuncoesHelper.pushRouter(Rotas.ETAPAS.nome, {
					identificador: this.identificador,
					modulo: this.modulo,
					localRealizacao: this.localRealizacao,
					etapa: etapaAnterior
				})
			}
		},
		avancarEtapa() {
			let proximaRota = {
				nome: Rotas.RESUMO.nome, params: {
					identificador: this.identificador,
					modulo: this.modulo,
					localRealizacao: this.localRealizacao
				}
			}

			if(parseInt(this.etapaAtual) !== parseInt(Object.keys(this.dadosComponentes).length)) {
				let proximaEtapa = Object.entries(this.dadosComponentes).filter(([etapa, componentes]) => etapa > this.etapaAtual && Object.values(componentes).length > 0)
				proximaEtapa = proximaEtapa.length > 0 ? proximaEtapa[0][0] : null

				if(proximaEtapa && proximaEtapa !== null) {
					proximaRota = {
						nome: Rotas.ETAPAS.nome, params: {
							identificador: this.identificador,
							modulo: this.modulo,
							localRealizacao: this.localRealizacao,
							etapa: parseInt(proximaEtapa)
						}
					}
				}

			}
			FuncoesHelper.pushRouter(proximaRota.nome, proximaRota.params);
		}
	},
	setup() {
		return EtapasService.setup()
	}
})
</script>
